var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#434864",
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 250,
    cy: 250,
    r: 250
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "database"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    fill: "#fff",
    d: "M256.48,267.48c-51.77,0-95.15-15.21-107-35.71A22.47,22.47,0,0,0,146.17,243v33.56c0,25.92,49.41,47,110.31,47s110.42-21,110.42-47V243a22.26,22.26,0,0,0-3.32-11.25C351.65,252.27,308.31,267.48,256.48,267.48Z",
    transform: "translate(-6.5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    fill: "#fff",
    d: "M256.48,336.79c-51.77,0-95.15-15.23-107-35.69a22.4,22.4,0,0,0-3.31,11.23V345.9c0,26,49.41,47,110.31,47s110.42-21,110.42-47V312.33a22.11,22.11,0,0,0-3.32-11.21C351.65,321.56,308.31,336.79,256.48,336.79Z",
    transform: "translate(-6.5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    fill: "#fff",
    d: "M363.81,164.65c-2.18,19-49.31,34.2-107.35,34.2s-105.13-15.2-107.29-34.2a22.43,22.43,0,0,0-3,10.75V209c0,25.94,49.41,47,110.31,47S366.9,235,366.9,209v-33.6A22.31,22.31,0,0,0,363.81,164.65Z",
    transform: "translate(-6.5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    fill: "#fff",
    d: "M256.48,188.29c59.44,0,107.52-16,107.52-35.64s-48.08-35.52-107.52-35.52S149,133.06,149,152.67,197.12,188.29,256.48,188.29Z",
    transform: "translate(-6.5 -5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataList);
export default __webpack_public_path__ + "static/media/iconDataList.4d4bf10af014d7318bb17ae436545411.svg";
export { ForwardRef as ReactComponent };